import { useState, Fragment } from "react";
import { Grid } from "@material-ui/core";
import { formatSSN } from "../../../../../../utils/commonFunctions/SSN";

import "./ksopPersonalInformation.css";
/* eslint-disable */

const PersonalInformationBlock = ({ field, value, isPrintable }) => {
	return (
		<div className="inside-item-border">
			<Grid container spacing={0}>
				<Grid item xs={6}>
					<div className={isPrintable ? "font-size-12" : "font-size-14"}>{field}</div>
				</Grid>
				<Grid item xs={6}>
					{" "}
				</Grid>
				<Grid item xs={6}>
					{" "}
				</Grid>
				<Grid item xs={6}>
					<div className={isPrintable ? "font-size-12" : "font-size-14"}>{value}</div>
				</Grid>
			</Grid>
		</div>
	);
};

const KsopPersonalInformation = (props) => {
	// const { employeeDetails } = props;
	// const { SSN, email, first_name, last_name } = employeeDetails;
	return (
		<div className="ksop-block">
			<div className="side-box">Must Complete</div>
			<div className="content-box-gray">
				<div className="title">Personal Information (Please Print or Type)</div>

				<div className="content">
					<Grid container spacing={0}>
						<Grid item xs={6}>
							<PersonalInformationBlock
								field="Company Name"
								value="BROOKSHIRE BROTHERS, INC."
								isPrintable={props.isPrintable}
							/>
						</Grid>
						<Grid item xs={6}>
							<PersonalInformationBlock
								field="Contact/Plan I.D. Number"
								value="KSOP / 706751"
								isPrintable={props.isPrintable}
							/>
						</Grid>
						<Grid item xs={6}>
							{props?.employeeDetails?.first_name && props?.employeeDetails?.last_name ? (
								<PersonalInformationBlock
									field="Participant"
									value={props.employeeDetails.first_name + props.employeeDetails.last_name}
									isPrintable={props.isPrintable}
								/>
							) : null}
						</Grid>
						<Grid item xs={6}>
							{props?.employeeDetails?.SSN ? (
								<PersonalInformationBlock
									field="Social Security Number"
									value={formatSSN(props.employeeDetails.SSN)}
									isPrintable={props.isPrintable}
								/>
							) : null}
						</Grid>
						<Grid item xs={6}>
							{props?.employeeDetails?.phone_number ? (
								<div
									className={"inside-item " + (props.isPrintable ? "font-size-12" : "font-size-14")}
									style={{
										paddingLeft: "5px",
										paddingBottom: "2px"
									}}
								>
									<p>Phone Number or E-mail (if clarification is needed)</p>
									<p style={{ display: "flex" }}>
										Phone Number:{" "}
										<div style={{ color: "#c9c9c9", paddingLeft: "5px" }}>
											{props.employeeDetails.phone_number}
										</div>
									</p>
								</div>
							) : null}
						</Grid>
						<Grid item xs={6}>
							{props?.employeeDetails?.email ? (
								<div
									className={"inside-item " + (props.isPrintable ? "font-size-12" : "font-size-14")}
									style={{ paddingTop: "20px" }}
								>
									Email : <span>{props.employeeDetails.email}</span>
								</div>
							) : null}
						</Grid>
					</Grid>
				</div>
			</div>
		</div>
	);
};
export default KsopPersonalInformation;
